import { render } from "./Widget9.vue?vue&type=template&id=130aa4bb&ts=true"
import script from "./Widget9.vue?vue&type=script&lang=ts"
export * from "./Widget9.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__